import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ShowDialogParams } from '@/store/dialog/types';
import {
    getEditorTemplateObjectStore,
    AddTag,
    RemoveTag,
    IncrementAutosaveCounter,
} from '@/store/templateEditor/actions';
import useMobile from '@/services/hooks/useMobile';
import { EditTagsModalBody } from '../components/EditTagsModalBody';

export const useEditTagsModalParams = (): {
    getEditTagsModalParams: () => ShowDialogParams;
} => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isMobile = useMobile();
    const templateObject = useSelector(getEditorTemplateObjectStore);

    const getEditTagsModalParams = (): ShowDialogParams => {
        const body = (
            <EditTagsModalBody
                onTagAdd={(tag: string): void => {
                    dispatch(AddTag(tag));
                    dispatch(IncrementAutosaveCounter());
                }}
                onTagRemove={(tag: string): void => {
                    dispatch(RemoveTag(tag));
                    dispatch(IncrementAutosaveCounter());
                }}
                isMobile={isMobile}
                templateObject={templateObject}
            />
        );
        return {
            title: t('addtags'),
            cancelLabel: t('close'),
            body,
            id: 'managetags',
        };
    };
    return { getEditTagsModalParams };
};
